import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ScrollDispatcher} from '@angular/cdk/scrolling';

@Component({
  selector: 'oap-menus-profil',
  templateUrl: './menus-profil.component.html',
  styleUrls: ['./menus-profil.component.scss']
})
export class MenusProfilComponent implements OnInit, OnDestroy {
    @Input() active: string;
    private subscribeScroll: Subscription;
    public windowTop: number;

  constructor(private scrollDispatcher: ScrollDispatcher,
              private cf: ChangeDetectorRef) {
      this.windowTop = window.pageYOffset;
  }

  ngOnInit() {
      this.subscribeScroll = this.scrollDispatcher.scrolled().subscribe(x => {
          this.windowTop = window.pageYOffset;
          this.cf.detectChanges();
      });
  }

  ngOnDestroy() {
      this.subscribeScroll.unsubscribe();
  }

}
